import { render, staticRenderFns } from "./LineOaIcon.vue?vue&type=template&id=0a2647ae&"
import script from "./LineOaIcon.vue?vue&type=script&lang=js&"
export * from "./LineOaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports